/*
 * ILS — Region switcher href rewriter (TASK-2395).
 *
 * The footer country picker (custom-footer.liquid) renders anchor buttons
 * whose href is the LIVE market root only, e.g.
 *   https://ilovesnacks.eu/de-de/
 * Baseline behaviour before this file: clicking any flag dropped the visitor
 * on the market landing page, discarding whichever product / collection /
 * page they were viewing. Owner wants the current path preserved across the
 * switch — Germany from a product page should land on the SAME product in
 * the German market, not the German homepage.
 *
 * Approach (Rule 3 — JS injection preferred over Liquid edits):
 *   1. On DOM ready, read window.location.pathname.
 *   2. Detect the current locale prefix at the start of the path — any
 *      "/xx-xx/" segment (two-letter language, two-letter country).
 *   3. Strip that prefix and remember the rest ("/products/foo" or "/" if
 *      user was on the market root already).
 *   4. Walk every .ils-footer__country-btn, parse its origin + market prefix
 *      from the pre-rendered href, and rewrite href to
 *      "<origin>/<new-market-prefix><rest><query>".
 *
 * If the current URL has no locale prefix (e.g. domain root with default
 * market), we treat the full path as `rest` — buttons will point to
 * "<origin>/<new-market-prefix>/<full-path>", which is what Shopify Markets
 * itself does when auto-redirecting.
 *
 * If JS never runs (blocked / stale cache), buttons still work — they just
 * fall back to the market roots baked into the Liquid, i.e. the pre-2395
 * behaviour. Progressive enhancement, not a hard dependency.
 */
(function () {
  'use strict';

  var LOCALE_PREFIX_RE = /^\/([a-z]{2})-([a-z]{2})(?=\/|$)/i;

  function computeRest() {
    var path = window.location.pathname || '/';
    var m = path.match(LOCALE_PREFIX_RE);
    var rest = m ? path.slice(m[0].length) : path;
    if (!rest || rest.charAt(0) !== '/') rest = '/' + rest;
    return rest;
  }

  function rewriteRegionLinks() {
    var links = document.querySelectorAll('.ils-footer__country-btn[href]');
    if (!links.length) return;

    var rest = computeRest();
    var search = window.location.search || '';

    // If we're on the market root ("/" after prefix strip), don't drag a
    // trailing empty query onto every button either.
    var restOnly = rest === '/' ? '/' : rest;

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      // Expect "https://host/xx-xx/" (or with any tail — we only care about
      // origin + market prefix, everything else is rebuilt).
      var mm = href.match(/^(https?:\/\/[^/]+)\/([a-z]{2}-[a-z]{2})(?:\/|$)/i);
      if (!mm) continue;
      var origin = mm[1];
      var marketPrefix = mm[2];
      a.setAttribute('href', origin + '/' + marketPrefix + restOnly + search);
    }
  }

  if (document.readyState !== 'loading') {
    rewriteRegionLinks();
  } else {
    document.addEventListener('DOMContentLoaded', rewriteRegionLinks);
  }
})();
